import React, { PureComponent, createRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import SliderContainer, { Slide } from './Slider';
import Asset from './Asset';
import UniversalLinkContainer from './UniversalLink';

export default class SelectedReviews extends PureComponent {
  state = {
    activeReviewIndex: 0,
  };

  constructor(props) {
    super(props);

    this.sliderRef = createRef();

    this.handleSliderChange = this.handleSliderChange.bind(this);
    this.handleNextClick = this.handleNextClick.bind(this);
    this.handlePrevClick = this.handlePrevClick.bind(this);
    this.renderReview = this.renderReview.bind(this);
    this.renderPagination = this.renderPagination.bind(this);
    this.renderReviewsWrapper = this.renderReviewsWrapper.bind(this);
    this.renderSlider = this.renderSlider.bind(this);
  }

  handleSliderChange(activeReviewIndex) {
    this.setState({ activeReviewIndex });
  }

  handleNextClick() {
    const { current } = this.sliderRef;
    if (current?.handleNextClick) {
      current.handleNextClick();
    }
  }

  handlePrevClick() {
    const { current } = this.sliderRef;
    if (current?.handlePrevClick) {
      current.handlePrevClick();
    }
  }

  renderReview(point, index) {
    const { activeReviewIndex } = this.state;
    const {
      header,
      subHeader,
      copy,
      links: [link],
    } = point;

    const { className: linkClassName, ...linkProps } = link || {};

    return (
      <div
        key={index}
        className={classNames('selected-reviews__review', {
          'selected-reviews__review--active': activeReviewIndex === index,
        })}
      >
        {header && (
          <h2 className="selected-reviews__review-header small-caps">{header}</h2>
        )}
        {copy && (
          <cite className="selected-reviews__review-citation h2">{copy}</cite>
        )}
        {link && (
          <div className="selected-reviews__review-links small-text">
            {`${subHeader} `}
            <UniversalLinkContainer
              {...linkProps}
              className={classNames('small-text', linkClassName)}
            >
              {link.text}
            </UniversalLinkContainer>
          </div>
        )}
      </div>
    );
  }

  renderPagination() {
    const { points } = this.props;
    const { activeReviewIndex } = this.state;

    return (
      <div className="selected-reviews__pagination">
        <div className="selected-reviews__pagination-dots">
          {points.map((_, index) => (
            <div
              key={index}
              className={classNames('selected-reviews__pagination-dot', {
                'selected-reviews__pagination-dot--active': index === activeReviewIndex,
              })}
            />
          ))}
        </div>
        <div className="selected-reviews__pagination-arrows">
          <div
            className="selected-reviews__pagination-arrow selected-reviews__pagination-arrow--prev icon icon-arrow-left"
            onClick={this.handlePrevClick}
          />
          <div
            className="selected-reviews__pagination-arrow selected-reviews__pagination-arrow--next icon icon-arrow-right"
            onClick={this.handleNextClick}
          />
        </div>
      </div>
    );
  }

  renderReviewsWrapper() {
    const { points } = this.props;

    return (
      <div className="selected-reviews__reviews-wrapper">
        <div className="selected-reviews__reviews">
          {points.length && points.map(this.renderReview)}
        </div>
        {this.renderPagination()}
      </div>
    );
  }

  renderSlider() {
    const {
      points,
      disableInfiniteSlider,
    } = this.props;

    return (
      <div className="selected-reviews__slider-container">
        <SliderContainer
          className="selected-reviews__slider"
          ref={this.sliderRef}
          slidesPerView={1}
          arrows={false}
          pagination={false}
          autoplay={true}
          onChange={this.handleSliderChange}
          onSwiper={this.onSwiper}
          disableInfinite={disableInfiniteSlider}
        >
          {points.map((point, index) => (
            <Slide key={index}>
              <Asset asset={Array.isArray(point.images) ? point.images[0] : null} />
            </Slide>
          ))}
        </SliderContainer>
      </div>
    );
  }

  render() {
    const {
      anchor,
      points,
    } = this.props;

    if (!Array.isArray(points)) {
      return null;
    }

    return (
      <section
        id={anchor || undefined}
        className="selected-reviews"
      >
        <div className="selected-reviews__container">
          {this.renderReviewsWrapper()}
          {this.renderSlider()}
        </div>
      </section>
    );
  }
}

SelectedReviews.defaultProps = {
  points: [],
};

const assetShape = PropTypes.shape({
  width: PropTypes.number,
  handle: PropTypes.string,
});

const linkShape = PropTypes.shape({
  type: PropTypes.string,
  header: PropTypes.string,
  text: PropTypes.string,
});

const pointShape = PropTypes.shape({
  header: PropTypes.string,
  subHeader: PropTypes.string,
  copy: PropTypes.string,
  images: PropTypes.arrayOf(assetShape),
  links: PropTypes.arrayOf(linkShape),
});

SelectedReviews.propTypes = {
  anchor: PropTypes.string,
  points: PropTypes.arrayOf(pointShape),
};
